import { BrowserRouter, Switch } from "react-router-dom";
import CheckRouter from "./router/checkRouter";
import { routers } from "./router/index";

function App() {
  return (
    <BrowserRouter>
      <Switch>
        <CheckRouter routers={routers} />
      </Switch>
    </BrowserRouter>
  );
}

export default App;
